// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"Layout-module--scrollbar--F7LcW","main":"Layout-module--main--2NQHS"};